﻿import { ClassicEditor as ClassicEditorBase, InlineEditor as InlineEditorBase } from '@eworx/ckeditor5';
import { instances } from '@eworx/ckeditor5';

import plugins from './Plugins';
import de from './translations/de';
import en from './translations/en';

import registerToolbars from './toolbars';
import { isFormEditor, isEventLayoutEditor, isLandingPageEditor } from './utils';

ClassicEditorBase.builtinPlugins = [
    ...ClassicEditorBase.builtinPlugins,
    ...plugins,
];
InlineEditorBase.builtinPlugins = [
    ...InlineEditorBase.builtinPlugins,
    ...plugins,
];

ClassicEditorBase.defaultConfig.translations = [de, en];
InlineEditorBase.defaultConfig.translations = [de, en];
ClassicEditorBase.defaultConfig.language = localStorage.user_ui_lang;
InlineEditorBase.defaultConfig.language = localStorage.user_ui_lang;


function setLinkOptions(config) {
    config = config || {};
    config.link = config.link || {};
    config.link.decorators = config.link.decorators || {};

    config.link.decorators.targetBlank = {
        id: 'setTargetBlank',
        mode: 'automatic',
        callback: _ => isFormEditor() && window.location.href.toLowerCase().indexOf('content/') > -1 || isEventLayoutEditor() || isLandingPageEditor(),
        attributes: {
            target: '_blank'
        }
    };

    config.link.defaultProtocol = 'https://';
}

class ClassicEditor extends ClassicEditorBase {
    static async create(element, config) {
        setLinkOptions(config);
        registerToolbars(config);

        return await super.create(element, config);
    }
}
class InlineEditor extends InlineEditorBase {
    static async create(element, config) {
        setLinkOptions(config);
        registerToolbars(config);
        return await super.create(element, config);
    }
}

// all exports will be available via "CKEDITOR5"
// see 'library' in webpack config
export { ClassicEditor, InlineEditor };
export { instances };
